export default __webpack_public_path__ + "static/cut-d-7ef46bd77c01150ec00af12edd5384b4.png";